import { useState, useEffect } from "react";
import {
  Typography,
  Button,
} from "@material-ui/core";

import { useStore } from "@store/store";
import Header from "@components/header";
import Loader from "@components/loader";
import {
  FETCH_BACK_DATED_EVENTS,
  FETCH_BACK_DATED_EVENTS_SUCCESS,
  FETCH_BACK_DATED_EVENTS_FAILURE,
  REVIEW_IMPACTED_CUSTOMERS,
  REVIEW_IMPACTED_CUSTOMERS_SUCCESS,
  REVIEW_IMPACTED_CUSTOMERS_FAILURE,
  RETRY_RECALCULATE_AND_GENERATE_DRAFT_INVOICE,
  RETRY_RECALCULATE_AND_GENERATE_DRAFT_INVOICE_SUCCESS,
  RETRY_RECALCULATE_AND_GENERATE_DRAFT_INVOICE_FAILURE
} from "@utils/actionTypes";
import { rowsPerPageVal, fsBackDatedStatus } from "@utils/constant";
import API from "@services/axios";
import TableListing from "./table-listing";
import { BackDatedEventsStyle } from "./style";
import { toast } from "react-toastify";

function MonthlyRateUpdates() {
  const classes = BackDatedEventsStyle();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageVal);
  const [state, dispatch] = useStore();
  const [order, setOrder] = useState("");
  const [orderBy, setOrderBy] = useState("");
  const [selectedArray, setSelectedArray] = useState([]);

  const getBackDatedEvents = () => {
    const params = {
      page: page + 1,
      size: rowsPerPage,
      order: order !== "" ? order : "desc",
      orderBy: orderBy !== "" ? orderBy : "status",
      isMonthly: true
    };
    dispatch({ type: FETCH_BACK_DATED_EVENTS });
    API.get("customers/backDatedEvents", { params })
      .then((response) => {
        dispatch({
          type: FETCH_BACK_DATED_EVENTS_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({ type: FETCH_BACK_DATED_EVENTS_FAILURE, payload: error });
      });
  };

  useEffect(() => {
    getBackDatedEvents();
  }, [page, rowsPerPage, order, orderBy]);

  const updateBackDatedStatus = async (surchargeBackDateIds) => {
    dispatch({ type: REVIEW_IMPACTED_CUSTOMERS });
    try {
      const response = await API.put("customers/updateBackDatedStatus", { surchargeBackDateIds });
      dispatch({
        type: REVIEW_IMPACTED_CUSTOMERS_SUCCESS,
        payload: response.data.data,
      });

      toast.success("Back-dated events dismissed. No changes were made to jobs or invoices.");
      getBackDatedEvents();
    } catch (error) {
      dispatch({ type: REVIEW_IMPACTED_CUSTOMERS_FAILURE, payload: error });
      toast.error("Back-dated events dismiss failed");
    }
  };

  const retryRecalculateAndGenerateDraftInvoice = async (surchargeBackDateIds) => {
    dispatch({ type: RETRY_RECALCULATE_AND_GENERATE_DRAFT_INVOICE });
    try {
      const response = await API.put("customers/retryRecalculateAndGenerateDraftInvoice", { surchargeBackDateIds });
      dispatch({
        type: RETRY_RECALCULATE_AND_GENERATE_DRAFT_INVOICE_SUCCESS,
        payload: response.data.data,
      });
      toast.success(response.data.message);
      getBackDatedEvents();
    } catch (error) {
      dispatch({ type: RETRY_RECALCULATE_AND_GENERATE_DRAFT_INVOICE_FAILURE, payload: error });
      toast.error(error.response.data.message);
    }
  };

  const handleListDismiss = async () => {
    await updateBackDatedStatus(selectedArray);
    setSelectedArray([]);
  };

  const handleDismiss = async (item) => {
    await updateBackDatedStatus([item.id]);
  };

  const handleListRetry = async () => {
    await retryRecalculateAndGenerateDraftInvoice(selectedArray);
    setSelectedArray([]);
  };

  const handleRetry = async (item) => {
    await retryRecalculateAndGenerateDraftInvoice([item.id]);
  };

  const handleChange = (item) => {
    let id = item.id;
    const selectedIndex = selectedArray.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedArray, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedArray.slice(1));
    } else if (selectedIndex === selectedArray.length - 1) {
      newSelected = newSelected.concat(selectedArray.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedArray.slice(0, selectedIndex),
        selectedArray.slice(selectedIndex + 1),
      );
    }

    setSelectedArray(newSelected);
  };

  const handleMainChangeCheckBox = (e) => {
    if (e.target.checked) {
      const newSelected = state.customer?.backDatedEventsData?.rows
        .filter((n) => n.status === fsBackDatedStatus.failed)
        .map((n) => n.id);
      setSelectedArray(newSelected);
    } else {
      setSelectedArray([]);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSorting = (event, property) => {
    const isAsc = orderBy === property.sortTitle && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property.sortTitle);
  };
  return (
    <>
      <Header />
      <div className={classes.CustomerListingWrapper}>
        <Loader
          loading={
            state?.customer?.reviewingImpacted ||
            state?.customer?.loadingBackDatedEvents ||
            state?.customer?.refreshingImpactedJobAndInvoice ||
            state?.customer?.retryingRecalculateAndGenerateDraftInvoice
          }
        />
        <div className="dashboard-page wrapper">
          <div className="inner-page">
            <div className={classes.innerPageTopBlock}>
              <div className="left-block">
                <Typography variant="h1">Monthly Rate Updates</Typography>
              </div>
              <div className="right-block">
                <div className="right-block-inner">
                  <Button
                    onClick={() => handleListRetry()}
                    color="primary"
                    className="orange-btn primary-btn center-loading-indicator"
                    disabled={
                      selectedArray.length === 0
                      || state.customer?.backDatedEventsData?.rows
                        ?.filter((item) => item.status === fsBackDatedStatus.failed).length === 0
                    }
                  >
                    RETRY
                  </Button>
                  <Button
                    onClick={() => handleListDismiss()}
                    color="primary"
                    className="orange-btn primary-btn center-loading-indicator"
                    disabled={
                      selectedArray.length === 0
                      || state.customer?.backDatedEventsData?.rows
                        ?.filter((item) => item.status === fsBackDatedStatus.failed).length === 0
                    }
                  >
                    DISMISS
                  </Button>
                </div>
              </div>
            </div>
            <TableListing
              handleDismiss={handleDismiss}
              handleRetry={handleRetry}
              handleChange={handleChange}
              handleMainChange={handleMainChangeCheckBox}
              selectedArray={selectedArray}
              page={page}
              handleChangePage={handleChangePage}
              rowsPerPage={rowsPerPage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              handleSorting={(e, property) => handleSorting(e, property)}
              orderBy={orderBy}
              order={order}
            />
          </div>
        </div>
      </div>
    </>
  );
}
export default MonthlyRateUpdates;
